import React, { useState, useEffect } from 'react';
import './NewsHeadline.css';

function NewsHeadline() {
  const [newsHeadline, setNewsHeadline] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchNewsHeadline = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://backend.mainbazar777.site/api/news-headline');
        if (!response.ok) {
          throw new Error('Failed to fetch news');
        }
        const data = await response.json();
        if (data.news_headline) {
          setNewsHeadline(data.news_headline);
        }
      } catch (err) {
        console.error('Error fetching news headline:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchNewsHeadline();
  }, []);

  if (!newsHeadline) {
    return null;
  }

  return (
    <div className="news-headline-container">
      <marquee className="news-marquee" behavior="scroll" direction="left" scrollamount="3">
        <span className="news-text">📰 {newsHeadline}</span>
      </marquee>
    </div>
  );
}

export default NewsHeadline;

